<template>
  <OnboardingFormLayout :show-error-message="showError">
    <OnboardingAddressForm
      ref="form"
      :show-mailing-address-fields="false"
      @validationSuccess="handleValidationSuccess"
      @validationFailure="showError = true"
      @goBack="goBack"
    />
  </OnboardingFormLayout>
</template>

<script>
import { mapGetters } from 'vuex';
import analytics, { SEGMENT_EVENTS } from '@/utils/analytics';
import { RouteNames } from '@/data/routes';
import { useProfiling } from '@/composables/useProfiling';
import { EVENT_TYPES } from '@/data/lexisnexis-types';

import OnboardingAddressForm from '@/pages/onboarding/components/OnboardingAddressForm.vue';
import OnboardingFormLayout from '@/pages/onboarding/components/OnboardingFormLayout.vue';

export default {
  components: {
    OnboardingAddressForm,
    OnboardingFormLayout,
  },
  data() {
    return {
      showError: false,
    };
  },
  setup() {
    const profiling = useProfiling(RouteNames.ONBOARDING.ADDRESS, {
      type: EVENT_TYPES.ACCOUNT_CREATION,
    });

    return {
      profiling,
    };
  },
  computed: {
    ...mapGetters(['paymentsOnboardingSteps', 'hasRevenueUnder10k']),
    currentRoute() {
      return this.$route.name;
    },
    previousRoute() {
      return this.paymentsOnboardingSteps[this.currentRoute].previousRoute.name;
    },
    nextRoute() {
      if (this.hasRevenueUnder10k) {
        return RouteNames.HOME.INITIAL;
      }
      return RouteNames.ONBOARDING.REVENUE_ACCOUNT;
    },
  },
  methods: {
    async updateOnboardingStep() {
      this.$store.dispatch(
        'UPDATE_PAYMENTS_ONBOARDING_STEP',
        this.currentRoute,
      );
      analytics.track(SEGMENT_EVENTS.SUBMITTED_REGISTERED_ADDRESS);

      this.$router.push({
        name: this.nextRoute,
      });
    },
    async handleValidationSuccess() {
      this.profiling.finish();

      await this.updateOnboardingStep();
    },
    goBack() {
      this.$router.push({ name: this.previousRoute });
    },
  },
};
</script>
